// extracted by mini-css-extract-plugin
module.exports = {"root":"StyledRoot-module__root___3Akoe"};